/*@ngInject*/
const ReferSubmissionRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.referSubmission = function (submissionId, reason, underwriterId, detail) {
        var url = '/rest/Submission/' + submissionId + '/Referral',
            body = {
                reason: reason,
                detail: detail,
                referredUnderwriterId: underwriterId,
                notification: notificationConstant.email.NONE
            };
        return this.post(url, body);
    };
};

angular.module('gw-um-submission')
    .service('referSubmissionRepository', ReferSubmissionRepository);
